export const propertiesSelectorCreator = (excludeProperty = []) => (state, componentProps = {}) => {
  const parsedObject = { ...state, ...componentProps };
  return Object.keys(parsedObject).reduce(
    (generated, key) => ({
      ...generated,
      ...(!excludeProperty.includes(key) && {
        [key]: parsedObject[key],
      }),
    }),
    {},
  );
};
